var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"icon-button",attrs:{"type":_vm.type}},_vm.$listeners),[_c('icon',{attrs:{"name":_vm.name,"tag":_vm.tag}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }